import React from 'react';
import DefaultImage from '@/assets/images/defaultImage.jpg';
import { TeaserCardComponentProps } from '@/components/features/cms/blocks/TeaserCard/register';
import { TeaserCard as DSTeaserCard } from '@/components/shared';
import { useDamFile } from '@/contexts/DamFileProvider';
import { MediaSet } from '@/types/media';

const fallBackImage: MediaSet = {
	size180: { url: DefaultImage },
	size320: { url: DefaultImage },
	size480: { url: DefaultImage },
	size720: { url: DefaultImage },
	size960: { url: DefaultImage },
	size1280: { url: DefaultImage },
	size1920: { url: DefaultImage },
};

type TeaserCardProps = TeaserCardComponentProps;

export const TeaserCard: React.FunctionComponent<TeaserCardProps> = ({
	image,
	altText,
	text,
	title,
	icon,
	url,
	ctaLabel,
	hideCtaLabel,
	ctaButtonVariant,
}) => {
	const damImage = useDamFile(image ?? null) ?? fallBackImage;

	return (
		<DSTeaserCard
			image={damImage}
			altText={altText}
			text={text}
			title={title}
			icon={icon}
			url={url}
			ctaLabel={ctaLabel}
			hideCtaLabel={hideCtaLabel}
			buttonVariant={ctaButtonVariant}
		/>
	);
};
